import React from 'react'
import type { TextEditorProviderProps } from './TextEditorProvider.types'

export const TextEditorContext = React.createContext<
  Omit<TextEditorProviderProps, 'children'>
>({
  features: {
    tabAsNavigation: true,
    stickyToolbar: undefined,
  },
})

export function TextEditorProvider({
  children,
  features,
}: TextEditorProviderProps) {
  return (
    <TextEditorContext.Provider value={{ features }}>
      {children}
    </TextEditorContext.Provider>
  )
}
